// extracted by mini-css-extract-plugin
export default {"container":"zero-height-loading-animation2_container__HVc83"};